import { render } from "./AddTask.vue?vue&type=template&id=02447aba&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=02447aba&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02447aba"]])

export default __exports__